import React from 'react';

export default function Documents({className}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <defs>
        <filter id="Ellipse_94" width="48" height="48" x="0" y="0" filterUnits="userSpaceOnUse">
          <feOffset></feOffset>
          <feGaussianBlur result="blur" stdDeviation="3"></feGaussianBlur>
          <feFlood floodColor="#f5ff00" floodOpacity="0.518"></feFlood>
          <feComposite in2="blur" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
        <filter
          id="noun-folder-4641698"
          width="30.025"
          height="28.339"
          x="8.988"
          y="9.831"
          filterUnits="userSpaceOnUse"
        >
          <feOffset></feOffset>
          <feGaussianBlur result="blur-2" stdDeviation="3"></feGaussianBlur>
          <feFlood floodColor="#f5ff00" floodOpacity="0.8"></feFlood>
          <feComposite in2="blur-2" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
      </defs>
      <g data-name="Group 120">
        <g
          filter="url(#Ellipse_94)"
          transform="translate(-1267.78 -85.78) translate(1267.78 85.78)"
        >
          <g
            fill="none"
            stroke="#f5ff00"
            strokeWidth="2"
            data-name="Ellipse 94"
            transform="translate(9 9)"
          >
            <circle cx="15" cy="15" r="15" stroke="none"></circle>
            <circle cx="15" cy="15" r="14"></circle>
          </g>
        </g>
        <g
          filter="url(#noun-folder-4641698)"
          transform="translate(-1267.78 -85.78) translate(1267.78 85.78)"
        >
          <path
            fill="#f5ff00"
            fillRule="evenodd"
            stroke="#f5ff00"
            strokeWidth="0.5"
            d="M22 19.929H21.326c-.465 0-.789 0-1.041.02a1.348 1.348 0 00-.5.11 1.265 1.265 0 00-.577.577 1.348 1.348 0 00-.11.5c-.02.252-.02.576-.02 1.041v2.954a15.115 15.115 0 00.058 1.794 1.069 1.069 0 001.1 1.1 15.116 15.116 0 001.794.058h3.936a15.116 15.116 0 001.794-.058 1.069 1.069 0 001.1-1.1 15.119 15.119 0 00.058-1.794v-.281a15.119 15.119 0 00-.058-1.794 1.069 1.069 0 00-1.1-1.1 15.116 15.116 0 00-1.794-.058h-.852c-.133 0-.224 0-.311-.007a2.108 2.108 0 01-1.563-.907c-.05-.072-.095-.152-.161-.267l-.009-.015c-.078-.136-.1-.183-.132-.223a1.265 1.265 0 00-.938-.544zm-.241-.848c.133 0 .224 0 .311.007a2.108 2.108 0 011.563.907c.05.072.095.152.161.267l.009.015c.078.136.1.183.132.223a1.265 1.265 0 00.938.544h1.124a15.419 15.419 0 011.876.066 1.888 1.888 0 011.822 1.822 15.422 15.422 0 01.065 1.876v.343a15.422 15.422 0 01-.065 1.876 1.888 1.888 0 01-1.822 1.822 15.422 15.422 0 01-1.876.065h-4a15.424 15.424 0 01-1.876-.065 1.888 1.888 0 01-1.822-1.822 15.422 15.422 0 01-.065-1.876v-3c0-.443 0-.8.023-1.09a2.163 2.163 0 01.194-.8 2.108 2.108 0 01.961-.961 2.163 2.163 0 01.8-.193c.29-.023.647-.023 1.09-.023h.45z"
            data-name="noun-folder-4641698"
          ></path>
        </g>
      </g>
    </svg>
  );
}
